export default __webpack_public_path__ + "static/media/connection_ln.4f8c2185.svg";